import React from "react";
import Link from "next/link";
import countReduce from "@/utils/countReduce";
import router, { useRouter } from "next/navigation";

export interface TrendingTag {
  tag_name: string;
  total_tagged: number;
  tag_id: string;
}

interface TrendingTagsProps {
  tags: TrendingTag[];
  handleItemClick?: () => void;
}

const TrendingTags: React.FC<TrendingTagsProps> = ({
  tags = [],
  handleItemClick,
}) => {
  const router = useRouter();
  const onSeeMoreClick = () => {
    console.log("See more clicked");
    router.push("/explore?tab=trending");
  };
  return (
    <div
      className="flex-none w-full md:w-80 lg:w-auto p-4 rounded-lg shadow-2xl bg-settings overflow-auto  lg:overflow-visible lg:max-h-none"
      onClick={handleItemClick}
    >
      <div className="flex  items-center justify-between gap-2 mb-1">
        <h2 className="text-lg font-semibold whitespace-normal">Trending</h2>
        <button
          type="button"
          onClick={onSeeMoreClick}
          className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium text-blue-600 hover:text-blue-700 dark:text-blue-600 dark:hover:text-blue-200 bg-blue-50/70 hover:bg-blue-100/80 dark:bg-blue-500/10 dark:hover:bg-blue-500/20 backdrop-blur-sm whitespace-nowrap"
        >
          See more &rarr;
        </button>
      </div>
      <p className="text-sm text-gray-500 dark:text-white/50 mb-1 whitespace-normal">
        Discover what&apos;s hot right now!
      </p>
      <ul className="space-y-1 bg-white/90 dark:bg-gray-900/90 rounded-lg p-2">
        {tags.map((x, idx) => (
          <li key={x.tag_id} className="flex items-center space-x-2  ">
            <Link
              href={`/tags/${x.tag_name}`}
              className="mr-4"
              data-cy="trending-tag-click"
            >
              <span className="text-blue-500 font-bold text-sm whitespace-nowrap mr-2">
                #{x.tag_name}
              </span>
              {x.total_tagged > 0 && (
                <span className="text-xs text-gray-500 dark:text-white/75 whitespace-nowrap">
                  {countReduce(x.total_tagged)}
                </span>
              )}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TrendingTags;
